import React from 'react';
import moment from 'moment';
import { FullStar } from '../../assets/images';
import { commaingNumber } from '../../utils';
class OverallManager {
  constructor(data) {
    this.data = data;
    this.overall = this.data[0].sort((a, b) => new Date(b['start_date']) - new Date(a['start_date']));
    this.overallSavings = this.data[1].sort((a, b) => new Date(b['start_date']) - new Date(a['start_date']));
    this.overallRatings = this.data[2].sort((a, b) => new Date(b['start_date']) - new Date(a['start_date']));
    this.overallNetwork = this.data[3].sort((a, b) => new Date(b['start_date']) - new Date(a['start_date']));
    this.savingsData = this.getSavingsOrSpentData('total_savings');
    this.spentData = this.getSavingsOrSpentData('total_spend');
    this.overallData = this.getOverallData();
    this.ratingsData = this.getOverallRatingsData();
    this.networkData = this.getOverallNetworkData();
  }

  apiResponse = () => {
    return this.data;
  };

  getStartAndEndDate = (start_date, end_date, labels) => {
    let startDate = moment(start_date).format('YY/MMM').split('/').reverse().join(' ');
    let endDate = moment(end_date).format('YY/MMM').split('/').reverse().join(' ');

    start_date = Date.parse(start_date);
    end_date = Date.parse(end_date);
    const currentDate = Date.parse(new Date());
    if (currentDate >= start_date && currentDate <= end_date && !labels.includes('Current Year'))
      return ['Current Year'];
    else if (
      currentDate > end_date &&
      (currentDate - end_date) / (1000 * 3600 * 24) < 366 &&
      !labels.includes('Last Year')
    )
    return ['Last Year'];

    return [startDate, endDate];
  };

  getContentdatestr = (str) => {
    let contentdatestr = '',
      color = '';
    if (str === 'Current Year') {
      contentdatestr = 'current contract year';
      color = '#5A8BED';
    } else if (str === 'Last Year') {
      contentdatestr = 'previous contract year';
      color = '#C7CDE0';
    } else {
      contentdatestr = str;
      color = '#C7CDE0';
    }

    return [contentdatestr, color];
  };

  getOverallData = () => {
    let labels = [];
    let data = [];
    let content = [];
    let max = 0;
    let barColors = [];
    const length = this.overall.length;
    this.overall.forEach((item, index) => {
      let str = this.getStartAndEndDate(item.start_date, item.end_date, labels).join(' - ');

      labels.push(str);
      data.push(item.appointments_count);
      if (max < item.appointments_count) max = item.appointments_count;

      const [contentdatestr, color] = this.getContentdatestr(str);
      barColors.push(color);

      content.push(
        <div className={`text-lg text-gray-600 ml-9 ` + (index === length - 1 ? '' : 'mb-8')}>
          <span className='font-semibold text-gray-700'>
            {item.appointments_count
              ? commaingNumber(item.appointments_count)
              : 'No'}
          </span>{' '}
          vaccination completed in {['Current Year', 'Previous Year'].includes(str) ? 'the ' : 'between '}
          <span className='font-semibold text-gray-700'>{contentdatestr}</span>
        </div>
      );
    });

    let stepSize = Math.ceil(max / 4);
    if (stepSize > 9) {
      stepSize = String(stepSize + (10 - (stepSize % 10)));
      stepSize = Number(Number(stepSize[0]) + 1 + new Array(stepSize.length - 1).fill(0).join(''));
    }

    return {
      labels,
      data,
      barColors,
      content,
      max,
      stepSize,
    };
  };

  getSavingsOrSpentData = (type) => {
    let labels = [];
    let data = [];
    let content = [];
    let max = 0;
    let barColors = [];
    const length = this.overallSavings.length;
    this.overallSavings.forEach((item, index) => {
      let str = this.getStartAndEndDate(item.start_date, item.end_date, labels).join(' - ');

      labels.push(str);
      data.push(item[type]);
      if (max < item[type]) max = item[type];

      const [contentdatestr, color] = this.getContentdatestr(str);
      barColors.push(color);

      content.push(
        <div className={`text-lg text-gray-600 ml-9 ` + (index === length - 1 ? '' : 'mb-8')}>
          <span className='font-semibold text-gray-700'>{item[type] ? '₹ ' + commaingNumber(item[type]) : 'No'}</span>{' '}
          amount {type === 'total_spend' ? 'spent' : 'saved'} on{' '}
          <span className='font-semibold text-gray-700'>{item.appointments_count} vaccination</span> in{' '}
          {['Current Year', 'Previous Year'].includes(str) ? 'the ' : 'between '}
          <span className='font-semibold text-gray-700'>{contentdatestr}</span>
        </div>
      );
    });

    let stepSize = Math.ceil(max / 4);
    if (stepSize > 9) {
      stepSize = String(stepSize + (10 - (stepSize % 10)));
      stepSize = Number(Number(stepSize[0]) + 1 + new Array(stepSize.length - 1).fill(0).join(''));
    }

    return {
      labels,
      data,
      barColors,
      content,
      max,
      stepSize,
    };
  };

  getOverallRatingsData = () => {
    let labels = [];
    let data = [];
    let content = [];
    let max = 0;
    let barColors = [];
    const length = this.overallRatings.length;
    this.overallRatings.forEach((item, index) => {
      let str = this.getStartAndEndDate(item.start_date, item.end_date, labels).join(' - ');

      labels.push(str);
      data.push(item.total_ratings);
      if (max < item.total_ratings) max = item.total_ratings;

      const [contentdatestr, color] = this.getContentdatestr(str);
      barColors.push(color);

      content.push(
        <div
          className={
            `text-lg text-gray-600 flex ` +
            (index === length - 1 ? '' : 'mb-8') +
            (item.total_ratings ? ' ml-9' : ' ml-14')
          }
        >
          {item.total_ratings && (
            <img src={FullStar} className='mr-2 mt-1' style={{ height: '15px', width: '15px' }} alt='star' />
          )}
          <span>
            <span className='font-semibold text-gray-700'>
              {item.total_ratings ? item.total_ratings : 'No'}&nbsp; vaccination
            </span>{' '}
            rating given by your employees in {['Current Year', 'Previous Year'].includes(str) ? 'the ' : 'between '}
            <span className='font-semibold text-gray-700'>{contentdatestr}</span>
          </span>
        </div>
      );
    });

    let stepSize = 1;

    return {
      labels,
      data,
      barColors,
      content,
      max,
      stepSize,
    };
  };

  getOverallNetworkData = () => {
    let labels = [];
    let data = [];
    let content = [];
    let max = 0;
    let barColors = [];
    const length = this.overallNetwork.length;
    this.overallNetwork.forEach((item, index) => {
      let str = this.getStartAndEndDate(item.start_date, item.end_date, labels).join(' - ');

      labels.push(str);
      data.push(item.cities);
      if (max < item.cities) max = item.cities;

      const [contentdatestr, color] = this.getContentdatestr(str);
      barColors.push(color);

      content.push(
        <div className={`text-lg text-gray-600 ml-9 ` + (index === length - 1 ? '' : 'mb-8')}>
          <span className='font-semibold text-gray-700'>
            {item.cities ? commaingNumber(item.cities) : 'No'}&nbsp;centers
          </span>{' '}
          covered in {['Current Year', 'Previous Year'].includes(str) ? 'the ' : 'between '}
          <span className='font-semibold text-gray-700'>{contentdatestr}</span>
        </div>
      );
    });

    let stepSize = Math.ceil(max / 4);
    if (stepSize > 9) {
      stepSize = String(stepSize + (10 - (stepSize % 10)));
      stepSize = Number(Number(stepSize[0]) + 1 + new Array(stepSize.length - 1).fill(0).join(''));
    }
    return {
      labels,
      data,
      barColors,
      content,
      max,
      stepSize,
    };
  };
}

export default OverallManager;
